<template>
  <div class="dboard-card">
    <loading-progress
      v-if="isLoading"
      :progress="60"
      :indeterminate=true
      :hide-background="true"
      size="64"
      rotate
      fillDuration="2"
      rotationDuration="1"
    />
    <div v-else>
      <div class="row row-space-nextline">
        <div class="col-lg-6 border">
          <div class="dboard-card-title">
            Active Indents
          </div>
          <div class="dboard-card-panel">
            <div class="dboard-card-panel-section">
              <div class="dboard-card-section-primarynumber primary-text">
                {{activeIntends}}
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 border">
          <div class="dboard-card-title">
            Total Indents
          </div>
          <div class="dboard-card-panel">
            <div class="dboard-card-panel-section">
              <div class="dboard-card-section-primarynumber primary-text">
                {{activeIntends + count.delivered}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-space-nextline">
        <div class="col-lg-4 border">
          <div class="dboard-card-title">
            Indented
          </div>
          <div class="dboard-card-panel">
            <div class="dboard-card-panel-section">
              <div class="dboard-card-section-primarynumber primary-text">
                  {{count.indent_accepted +
                    count.indented +
                    count.indent_assign_due +
                    count.indent_rejected}}
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="doughnut dsplinline-left">
            <CircleChart
            :accepted="count.indent_accepted"
            :pending="count.indented + count.indent_assign_due"
            :rejected="count.indent_rejected"
            />

          </div>
        </div>
        <div class="col-lg-4 border indents-values">
          <div class="dtable-container">
            <div class="dtable-row">
              <div class="dtable-cell dtable-cell-number">
                <span class="dboard-card-section-secnumber primary-text">
                  {{count.indent_accepted}}
                </span>
              </div>
              <div class="dtable-cell">
                <span class="dboard-card-section-sectitle primary-text">
                  Accepted
                </span>
              </div>
            </div>

            <div class="dtable-row">
              <div class="dtable-cell dtable-cell-number">
                <span class="dboard-card-section-secnumber sec-text number">
                  {{count.indented + count.indent_assign_due}}
                </span>
              </div>
              <div class="dtable-cell">
                <span class="dboard-card-section-sectitle primary-text">
                  Pending
                </span>
              </div>
            </div>

            <div class="dtable-row">
              <div class="dtable-cell dtable-cell-number">
                <span class="dboard-card-section-secnumber tertiary-text number">
                  {{count.indent_rejected}}
                </span>
              </div>
              <div class="dtable-cell">
                <span class="dboard-card-section-sectitle primary-text number">
                  Rejected
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-space">
        <div class="col-lg-6 border">
          <div class="dboard-card-title">
            Assigned
          </div>
          <div class="dboard-card-panel">
            <div class="dboard-card-panel-section">
              <div class="dboard-card-section-primarynumber primary-text">
                {{count.truck_assigned + count.truck_rejected}}
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="dboard-card-title">
            Arrived
          </div>
          <div class="dboard-card-panel">
            <div class="dboard-card-panel-section">
              <div class="dboard-card-section-primarynumber primary-text arrived-count">
                {{count.truck_arrived+count.loading_started+count.loading_ended}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-space">
        <div class="col-lg-6 border">
          <div class="dboard-card-title">
            Dispatched
          </div>
          <div class="dboard-card-panel">
            <div class="dboard-card-panel-section">
              <div class="dboard-card-section-primarynumber primary-text">
                {{count.dispatched}}
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="dboard-card-title">
            Delivered
          </div>
          <div class="dboard-card-panel">
            <div class="dboard-card-panel-section">
              <div class="dboard-card-section-primarynumber primary-text delivered-count">
                {{count.delivered}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import CircleChart from '../common/charts/Circle';

export default {
  props: {
    isLoading: {
      type: Boolean,
    },
    count: {
      type: Object,
    },
    activeIntends: {
      type: Number,
    },
  },
  components: {
    CircleChart,
  },
};
</script>
<style lang="scss">
  .doughnut canvas{
    width:70px !important;
    height:70px !important;
  }
  .total {
    position: absolute;
    top: 27px;
    left: 35px;
    font-size: 15px;
    color: #CADCFF;
  }
  .vue-progress-path {
    margin-left: 150px;
  }
  .stack-panel {
    float: none;
    display: block;
  }
  .dtable-container {
    display: table;
    float: right;
  }
  .dtable-row {
    display: table-row;
  }
  .dtable-cell {
    display: table-cell;
    padding: 2px;
    padding-right: 5px;
    vertical-align: middle;
    &-number {
      text-align: right;
    }
  }
  .row-space {
    margin-bottom: 10px;
    &-nextline {
      margin-bottom: 30px;
    }
  }
  .arrived-count {
    color: #7BAAFF;
  }
  .delivered-count {
    color: #FFFFFF;
  }
</style>
